import classNames from "classnames";

export const Label = ({htmlFor, className = '', variant = 'site', children}) => {
    return (
        <label htmlFor={htmlFor} className={classNames(`formLabel`, `formLabel--${variant}`, className)}>
            {children}
        </label>
    );
}
